import * as React from "react"
import { forwardRef, memo } from "react"

const SvgComponent = (props, ref) => (
  <svg
    width={25}
    height={13}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="M2.705 12.84 0 1.07l7.439 5.35L12.172 0l4.734 6.42 7.438-5.35-2.704 11.77H2.705Z"
      fill="url(#a)"
    />
    <defs>
      <linearGradient
        id="a"
        x1={12.172}
        y1={0}
        x2={12.172}
        y2={22.871}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.1} stopColor="#F98600" />
        <stop offset={1} stopColor="#ECC0A7" />
      </linearGradient>
    </defs>
  </svg>
)

const ForwardRef = forwardRef(SvgComponent)
const Memo = memo(ForwardRef)
export default Memo
